import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { UserEquippedPet } from "types/user";
import { UserWithPet } from "components/VetStore/CoachPetAvatar";

type PostAuthorProps = {
  name?: string | null;
  pictureUrl?: string | null;
  subtitle?: string;
  size?: number;
  nameVariant?: "body2" | "caption";
  equippedStoreItems?: UserEquippedPet[] | null;
};

export const PostAuthor: FC<PostAuthorProps> = ({
  name,
  pictureUrl,
  subtitle,
  size = 36,
  nameVariant = "body2",
  equippedStoreItems,
}) => {
  return (
    <UserWithPet
      name={name}
      pictureUrl={pictureUrl}
      equippedStoreItems={equippedStoreItems}
      avatarSize={size}
      showName
      nameVariant={nameVariant}
      subtitle={
        subtitle ? (
          <Typography variant="caption" color="text.secondary" noWrap>
            {subtitle}
          </Typography>
        ) : undefined
      }
    />
  );
};
